// extracted by mini-css-extract-plugin
module.exports = {"main-component":"featureOther_main-component__1W6Cg"};